import { createSelector } from 'reselect';

export const selectMaterialCategoriesSlice = state => state.materialCategories;

export const selectMaterialCategories = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.materialCategories
);
export const materialCategoriesLoaded = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.materialCategoriesLoaded
);
export const selectActiveMaterialCategory = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.activeMaterialCategory
);

export const materialCategoriesMeta = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.meta
);
export const materialCategoriesFilters = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.filters
);

export const materialCategoryCreating = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.isCreating
);
export const materialCategoryUpdating = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.isUpdating
);
export const materialCategoryDeleting = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.isDeleting
);
export const materialCategoriesErrors = createSelector(
  selectMaterialCategoriesSlice,
  slice => slice.errors
);
